import { gql } from "@apollo/client"

export const CREATE_ACT_MULTI_DISTRICT_ADMIN = gql`
  mutation createACTMultiDistrictAdmin(
    $data: CreateACTMultiDistrictAdminRequest!
  ) {
    actMultiDistrictAdmin {
      create(data: $data)
    }
  }
`

export const UPDATE_ACT_MULTI_DISTRICT_ADMIN = gql`
  mutation updateACTMultiDistrictAdmin(
    $data: UpdateACTMultiDistrictAdminRequest!
  ) {
    actMultiDistrictAdmin {
      update(data: $data)
    }
  }
`

export const REMOVE_BATCH_ACT_MULTI_DISTRICT_ADMINS = gql`
  mutation removeBatchACTMultiDistrictAdmins(
    $data: ACTMultiDistrictAdminsIdsListRequest!
  ) {
    actMultiDistrictAdmin {
      removeBatch(data: $data)
    }
  }
`
